import { DataService } from './../../../services/data.service';
import { EnvService } from './../../../services/env.service';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LoginInfoProvider } from '../../../ev-dal/login-info.provider';
import { regexpPatterns } from '../../../shared/patterns';
import { CommonRequestResponseService } from 'app/services';
 
@Component({
  selector: 'app-heat-map',
  templateUrl: 'heat-map.component.html',
  styleUrls: ['./heat-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class HeatMapComponent implements OnInit {

  @Input() categoryList: any[];
  @Input() heatMapData: any[];
  @Input() studentPartnerId;
  @Input() buttonName;
  @Input() heatMapTypeId: number;
  @Output() showBrick = new EventEmitter();
  @Output() addBrick = new EventEmitter();
  isMobile = this.envService.getDevice() === 'mobile';
  role = this.loginInfoProvider.roleName.toLowerCase();
  color = this.dataService.getEntity('Brick Temperature').item;
  isCoach = this.loginInfoProvider.module.toLowerCase() === 'coach';
  isAdminHeatMap: boolean;
  colors = {};

  constructor(
    private loginInfoProvider: LoginInfoProvider,
    private envService: EnvService,
    private dataService: DataService
  ) {
  }

  ngOnInit() {
    this.setBrickColorData(this.color);
    const localStorageData = localStorage.getItem('currentPageData');
    this.isAdminHeatMap = localStorageData ? JSON.parse(localStorageData).path === 'heatMap' : false;
  }

  showBrickDetail(brick: any, category?: number, data?: string) {
    brick.heatMapDetails = brick.heatMapDetails ? brick.heatMapDetails.replace(regexpPatterns.breakTag, '<br/>') : '';
    this.showBrick.emit({
      brick,
      category,
      data
    })
  }

  onAddABrick(options: any) {
    this.addBrick.emit(options);
  }

  setBrickColorData(temperatures: any[]) {
    for (let i = 0; i < temperatures.length; i++) {
      if (temperatures[i].value) {
        this.colors[temperatures[i].id] = `linear-gradient(45deg,${temperatures[i].value.split(',')[0]},${temperatures[i].value.split(',')[1]})`;
      } else {
        this.colors[temperatures[i].value] = `linear-gradient(45deg,#A9A9A9,#A9A9A9)`;
      }
    }
  }
}
